import { Flex } from '@chakra-ui/react';
import { Button, Row } from 'reactstrap';
import { PlusCircle } from 'react-feather';
import React, { useEffect, useState } from 'react';
import Repeater from '@components/repeater';
import ElementControlled from './ElementControlled';

const RepeaterControlled = ({
	caption,
	value,
	first = {
		caption: 'Nombre',
		name: 'name'
	},
	second = {
		caption: 'Valor',
		name: 'value'
	},
	onChange
}) => {
	const [values, setValues] = useState(value || null);
	const handleChange = (element_index, element_name, element_value) => {
		const v = [...values];
		v[element_index][element_name] = element_value;
		setValues(v);
	};
	const handleDelete = (element_index, e) => {
		e.preventDefault();
		const v = [...values];
		const a = v.splice(element_index, 1);
		e.target.closest('div').remove();
		setValues(v);
	};

	const increaseCount = () => {
		const v = [...values];
		v.push({
			[first.name]: '',
			[second.name]: ''
		});
		setValues(v);
	};

	useEffect(() => {
		onChange({ value: values });
	}, [values]);

	return (
		<>
			<Repeater count={values?.length}>
				{(i) => (
					<Flex key={i} alignItems={'end'} gap={10}>
						<ElementControlled
							i={i}
							first={first}
							second={second}
							values={values}
							changeValues={handleChange}
							handleDelete={handleDelete}
						/>
					</Flex>
				)}
			</Repeater>
			<Row className="d-flex justify-content  m-0 my-2 ">
				<Button
					className="header-row-button"
					color="primary"
					onClick={increaseCount}
				>
					<PlusCircle />
					<span className="mx-auto font-medium-1">
						{caption || 'Agregar elemento'}
					</span>
				</Button>
			</Row>
		</>
	);
};

export default RepeaterControlled;
